var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-info"},_vm._l((_vm.infoList),function(item,i){return _c('div',{key:i,staticClass:"infoList"},[_c('div',{staticClass:"infoName"},[_vm._v(_vm._s(item.filedName))]),_c('div',{staticClass:"infoData"},[_vm._v(_vm._s(item.filedUnit))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }